var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._g(_vm._b({},'v-list',_vm.$attrs,false),_vm.$listeners),[_vm._t("prepend"),_vm._l((_vm.items),function(item,index){return [_c('nav-tree-item',{key:index,attrs:{"config":item}})]}),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }